/** Shared class names so drawers, forms and tables look the same everywhere. */

export const DRAWER_CLASS =
  'h-full !w-full !min-w-0 !max-w-full overflow-hidden flex flex-col sm:!w-[45vw] sm:!min-w-[650px] sm:!max-w-[45vw]';

export const FIELD_CLASS =
  'h-10 box-border border-gray-200 bg-white transition-colors focus-visible:border-[#4369a0] focus-visible:ring-1 focus-visible:ring-[#4369a0]/25';

export const READONLY_FIELD_CLASS = 'h-10 box-border border-gray-200 bg-gray-50 text-gray-600';

export const SELECT_FIELD_CLASS =
  '!h-10 box-border !py-0 rounded-sm border-gray-200 !bg-white text-gray-900 shadow-none transition-colors hover:!bg-white focus-visible:border-[#4369a0] focus-visible:ring-1 focus-visible:ring-[#4369a0]/25 [&_[data-placeholder]]:text-muted-foreground';

export const LABEL_CLASS = 'flex min-h-5 items-center text-gray-700';

export const ICON_BUTTON_CLASS =
  'h-8 w-8 rounded-md border border-gray-200 text-gray-500 hover:border-[#4369a0]/30 hover:bg-[#4369a0]/10 hover:text-[#4369a0] disabled:opacity-40';

export const SMALL_ICON_BUTTON_CLASS =
  'h-7 w-7 shrink-0 rounded-md border border-gray-200 text-gray-500 hover:border-[#4369a0]/30 hover:bg-[#4369a0]/10 hover:text-[#4369a0]';

export const PRIMARY_BUTTON_CLASS = 'bg-[#4369a0] text-white hover:bg-[#4369a0]/90 disabled:opacity-60';

export const SOFT_BUTTON_CLASS =
  'h-8 gap-1.5 border-[#4369a0]/30 bg-[#4369a0]/5 text-[#4369a0] hover:bg-[#4369a0]/10 hover:text-[#4369a0]';

export const DELETE_BUTTON_CLASS =
  'border-[#dc143c]/25 bg-[#dc143c]/10 text-[#dc143c] hover:bg-[#dc143c]/15 hover:text-[#b01030] hover:border-[#dc143c]/35';
